import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PortalReportingService } from './services/portal-reporting.service';
import { bindLocalStorage } from './shared/providers/bind-storage';

export enum SplitAreaState {
    None = 'None',
    Map = 'Map',
    IWI = 'IWI',
}

@Injectable({
    providedIn: 'root'
})
export class SplitAreaService {

    private readonly portalReportingService = inject(PortalReportingService);

    private readonly splitAreaCache = bindLocalStorage<SplitAreaState>('splitAreaCache');

    public splitAreaState$: BehaviorSubject<SplitAreaState>;

    public isMapVisible: boolean = false;
    public isIwiVisible: boolean = false;

    constructor(
    ) {
        // restore state from cache
        const splitAreaState = this.splitAreaCache() ?? SplitAreaState.None;

        this.splitAreaState$ = new BehaviorSubject<SplitAreaState>(splitAreaState);

        this.splitAreaState$.subscribe(res => {
            this.splitAreaCache.set(res);
            this.isMapVisible = res === SplitAreaState.Map;
            this.isIwiVisible = res === SplitAreaState.IWI;
        });
    }

    public toggleMapVisibility() {
        if (!this.isMapVisible) {
            this.portalReportingService.addAction('Hybrid map opened')
                .subscribe({
                    error: () => console.error('Error adding action')
                });
        }

        this.splitAreaState$.next(this.isMapVisible ? SplitAreaState.None : SplitAreaState.Map);
    }

    public toggleIwiVisibility() {
        this.splitAreaState$.next(this.isIwiVisible ? SplitAreaState.None : SplitAreaState.IWI);
    }
}
